import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    'cleanableField',
    'versionDetails',
    'collapseDetailsIcon',
    'collapseFilterIcon',
    'plusMinusIcon',
    'detailsLink'
  ];

  initialize() {
    this.hasDetailsLinkTarget && $(this.detailsLinkTarget).hover((ev) => this.toggleColor(ev, '#27597b'), (ev) => this.toggleColor(ev, 'unset'))
  }

  // stimulus-events
  clearFields(ev) {
    ev.stopPropagation();
    $(this.cleanableFieldTargets).val(null);
  }

  showDetails(ev) {
    ev.stopPropagation();
    let isCollapsed = $(ev.currentTarget).hasClass('active');
    this.plusMinusIconTargets.forEach(($el) => $el.classList.toggle('fa-search-plus', isCollapsed));
    this.versionDetailsTargets.forEach((el) => { isCollapsed ? $(el).slideUp("fast") : $(el).slideDown("fast") });
    this.collapseDetailsIconTargets.forEach(($el) => $el.classList.toggle('fa-chevron-up', !isCollapsed));
    ev.currentTarget.classList.toggle('active');
  }

  showDetail(ev) {
    ev.stopPropagation();
    $(ev.currentTarget).closest('li').find('section.card-footer').slideToggle("fast");
    $(ev.currentTarget).find('i.fa-search-minus').get(0).classList.toggle('fa-search-plus');
    $(ev.currentTarget).find('i.fa-chevron-down').get(0).classList.toggle('fa-chevron-up');
  }

  showFilterFields(ev) {
    ev.stopPropagation();
    $('form.form-filter').slideToggle("fast", () => {
      this.collapseFilterIconTarget.classList.toggle('fa-chevron-up');
    });
  }

  toggleColor(ev, value) {
    ev.stopPropagation();
    $('i.fa-search-minus').each((i, $el) => $($el).css('color', value));
  }
}
